import { API } from "../../backend";
//category calls
export const createCategory = (userId,token,category) => {
    return fetch(`${API}/category/create/${userId}`,{
    method:"POST",
    headers:{
    Accept:"application/json",
    "Content-Type":"application/json",
    Authorization :`Bearer ${token}`
    },
    body:JSON.stringify(category)               // look into postman....you had body as raw data...ithink so
    }).then(response=>{
        return response.json()
    })
    .catch(err=>console.log(err));
}
 


//get all categories
export const getCategories = () => {
    return fetch(`${API}/categories`,{
        method:"GET"
    }).then(response=>{
        return response.json();
    })
    .catch(err=>console.log(err));
}
 


//product calls
export const createaProduct = (userId, token, product) => {
    return fetch(`${API}/product/create/${userId}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`
      },
      body: product
    })
      .then(response => {
        return response.json();
      })
      .catch(err => console.log(err));
  };
 


//get all products
export const getAllProducts = () => {
    return fetch(`${API}/products`,{
        method:"GET"
    }).then(response=>{
        return response.json();
    })
    .catch(err=>console.log(err));
}
 


//get a single product
export const getproduct = (productId) => {
    return fetch(`${API}/product/${productId}`,{
        method:"GET"
    }).then(response=>{
        return response.json();
    }).catch(err=>console.log(err))
}
 

 
//update a product
export const updateProduct = (productId,userId,token,product) => {
    return fetch(`${API}/product/${productId}/${userId}`,{
    method:"PUT",
    headers:{
    Accept:"application/json",
    Authorization :`Bearer ${token}`
    },
    body:product               // look into postman....you had body as raw data...ithink so
    }).then(response=>{
        return response.json()
    })
    .catch(err=>console.log(err));
}
 


//delete a product
export const deleteaProduct = (userId,token,productId) => {
    return fetch( `${API}/product/${productId}/${userId}`,{
        method: "DELETE",
        headers:{
            Accept:"application/json",
            Authorization:`Bearer ${token}`
        }
    }).then(response=>{
        return response.json()
    })
    .catch(err=>console.log(err));
}

//delete category

export const updateCategory = (categoryId,userId,token,Category) => {
    return fetch(`${API}/category/${categoryId}/${userId}`,{
    method:"PUT",
    headers:{
    Accept:"application/json",
    Authorization :`Bearer ${token}`
    },
    body:Category               // look into postman....you had body as raw data...ithink so
    }).then(response=>{
        return response.json()
    })
    .catch(err=>console.log(err));
}


 
